import { Component, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less'],

    encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {

    private returnUrl: string;
    private busy: Boolean = true;

    constructor(private authService: AuthService,
        private activatedRoute: ActivatedRoute, private router: Router,
        private renderer2: Renderer2,
        private snackbar: MatSnackBar) {

        let params = this.activatedRoute.snapshot.queryParams;
        this.returnUrl = params['returnUrl'] || '/';
    }

    ngOnInit() {
        this.busy = true;

        if (this.authService.isLoggedIn()) {
            this.router.navigate([this.returnUrl]);
            return;
        }

        var tokenPromise = this.authService.silentLoginAzureAD();
        if (tokenPromise) {
            tokenPromise.then(aadToken => {
                this.authService.loginPPA(aadToken)
                    .subscribe(response => {
                        let result = response.json();

                        this.authService.setLoggedIn(result.access_token);
                        this.router.navigate([this.returnUrl]);
                        this.busy = false;
                    },
                    response => {
                        // TODO : Do something with error
                        this.snackbar.open(response.Message, null, { duration: 5000 });
                        this.busy = false;
                    });
            });
        } else {
            this.busy = false;
        }
    }

    login() {
        this.busy = true;

        var tokenPromise = this.authService.loginAzureAD();
        if (tokenPromise) {
            tokenPromise.then(aadToken => {
                this.authService.loginPPA(aadToken)
                    .subscribe(response => {
                        let result = response.json();

                        this.authService.setLoggedIn(result.access_token);
                        this.router.navigate([this.returnUrl]);
                        this.busy = false;
                    },
                    response => {
                        console.log(response);
                        // TODO : Do something with error
                        this.snackbar.open(response.Message, null, { duration: 5000 });
                        this.busy = false;
                    });
            });
        }
    }
}



// WEBPACK FOOTER //
// ./Angular/app/login/login.component.ts